/* eslint-disable react/prop-types */
import {
  Box,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const ScrollBarDesign = {
  maxHeight: "70vh",

  "&::-webkit-scrollbar-thumb": {
    background: "#BFD6F8",
  },
  "&::-webkit-scrollbar": {
    background: "#BFD6F8",
    width: "10px",
  },
  "&::-webkit-scrollbar-track": {
    "-webkit-box-shadow": "#BFD6F8",
  },
  "&:hover::-webkit-scrollbar-thumb": {
    background: "#BFD6F8",
  },
  "&::-webkit-scrollbar-button:single-button": {
    background: "#BFD6F8",
    display: "block",
    height: "12px",
    width: "12px",
  },
  "&::-webkit-scrollbar-button:single-button:vertical:decrement": {
    background:
      'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>\') center no-repeat',
  },
  "&::-webkit-scrollbar-button:single-button:vertical:increment": {
    background:
      'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>\') center no-repeat',
  },
  "&::-webkit-scrollbar-button:single-button:horizontal:decrement": {
    background:
      'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>\') center no-repeat',
  },
  "&::-webkit-scrollbar-button:single-button:horizontal:increment": {
    background:
      'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>\') center no-repeat',
  },
};
export default function CustomTable({ columns = [], rows = [], loading }) {
  return (
    <TableContainer
      sx={{
        maxHeight: `${window.innerHeight - 330}px`,
        overflow: "auto",
        ...ScrollBarDesign,
      }}
      component={Paper}
    >
      <Table stickyHeader aria-label="sticky table" sx={{ tableLayout: 'auto' }}>
        <TableHead>
          <TableRow>
            {columns.map((column) => {
             const minWidth = column.id === "SI No" ? "80px" : column?.width || "150px";
              return (
                <TableCell
                  key={column.id}
                  align={column?.align || "center"}
                  style={{
                    minWidth ,
                    padding: "15px 0px",
                    verticalAlign: "middle"

                  }}
                >
                  {column.label}
                  {
                    column.sort &&
                    <IconButton color="primary" onClick={() => column?.onSort()}>
                      <Box
                        component="img"
                        sx={{ cursor: "pointer" }}
                        onClick={() => column?.onSort()}
                        src={column?.icon}
                      />
                    </IconButton>

                  }


                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading
            ? rows.map((row, index) => {
              return (
                <TableRow role="checkbox" tabIndex={-1} key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
                >
                  {columns.map((column) => {
                    const value = row[column?.id];
                    return (
                      <TableCell
                        key={column?.id}
                        align={column?.align || "center"}
                        style={{ padding: "15px 0px" }}
                      >
                        {column.renderCell
                          ? column.renderCell(row, index)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
            : [...Array(5)].map((_, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ padding: "15px 10px" }}
                  >
                    <Skeleton />
                  </TableCell>
                ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
